import { UPLOAD_RESOURCE_FILE_API } from '../constants/AppConstants';

export default async (requestBody) => {
  try {
    const formData = new FormData();
    Object.entries(requestBody).forEach(([key, value]) => formData.append(key, value));

    const response = await fetch(UPLOAD_RESOURCE_FILE_API, {
      method: 'POST',
      body: formData,
      skipAuthHeader: true,
    });

    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: error.message } };
  }
};
